import React from 'react'
import styled from 'styled-components'
import {isProfileApp} from '../../utils/envUtils'

const LoadingView = styled.div`
  display: flex;
  justify-content: center;
  background-color: ${props => (isProfileApp() ? '#fff' : props.theme.shell?.loading?.backgroundColor || '#fff')};
  margin-top: ${props => (props.nomargin ? '0px' : '20vh')};
`

const Loading = ({className, nomargin}) => (
  <LoadingView className={className} nomargin={nomargin}>
    <img src="/assets/loading.svg" alt="loading" />
  </LoadingView>
)

export default Loading
